import AssignmentOutlinedIcon from "@mui/icons-material/AssignmentOutlined";
import TouchAppOutlinedIcon from "@mui/icons-material/TouchAppOutlined";
import AppsIcon from "@mui/icons-material/Apps";
import AssessmentOutlinedIcon from "@mui/icons-material/AssessmentOutlined";
import CreateOutlinedIcon from "@mui/icons-material/CreateOutlined";
import EventNoteOutlinedIcon from "@mui/icons-material/EventNoteOutlined";

export const interactions = [
  {
    id: "survey",
    interactionType: 0,
    icon: AssignmentOutlinedIcon,
    disabledIfNoAccess: true,
    visible: true, // visible in create menu
  },
  {
    id: "button",
    interactionType: 1,
    icon: TouchAppOutlinedIcon,
    disabledIfNoAccess: true,
    visible: true, // visible in create menu
  },
  {
    id: "app",
    interactionType: 2,
    icon: AppsIcon,
    disabledIfNoAccess: true,
    visible: false,
  },
  {
    id: "protocol",
    interactionType: null,
    icon: EventNoteOutlinedIcon,
    disabledIfNoAccess: true,
    visible: true,
  },
  {
    id: "moodboard",
    interactionType: null,
    icon: AssessmentOutlinedIcon,
    disabledIfNoAccess: false,
    visible: true,
  },
  {
    id: "note",
    interactionType: null,
    icon: CreateOutlinedIcon,
    disabledIfNoAccess: false,
    visible: true,
  },
];

export const getInteractionByType = (interactionType) => {
  return interactions?.[interactionType] ?? interactions[0];
};
